import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Container } from "react-bootstrap";
import { saveAs } from "file-saver";
import { extraerDatosAssessment } from "../assessmentExtractor";
import { generarDocumentoBOM } from "../bomGenerator";
import { generarDocumentoPropuestaComercial } from "../propuestaComercialGenerator";
import { generarDocumentoPropuestaEconomica } from "../propuestaEconomicaGenerator";
import { generarDocumentoKickoff } from "../kickoffGenerator";
import RevisionOrtografica from "../RevisionOrtografica";
import CalendarioProyecto from "../CalendarioProyecto";
import {
  generarSlugProyecto,
  guardarMetadataProyecto,
  listarProyectos,
  subirArchivoPaso,
  eliminarProyectoS3,
  generarSlugCliente,
  guardarMetadataCliente,
  listarClientes,
  eliminarClienteS3,
  listarArchivosPaso,
  descargarArchivoS3,
} from "../s3Cliente";
import "../../../../incidentes.css";
import EconomicaModal from "./EconomicaModal";
import PropuestaComercialModal from "./PropuestaComercialModal";
import {
  PASO_ASSESSMENT,
  PASO_BOM,
  PASO_PROPUESTA_TECNICO_FUNCIONAL,
  PASO_PROPUESTA_COMERCIAL,
  PASO_KICKOFF,
  PASOS_GENERADOS_DESDE_MACHOTE,
  DIAS_LIMITE_PROYECTO_DEFAULT,
  PASO_SIN_RETROCESO,
  PASO_MAX_VERSIONABLE,
  esPasoMultiple,
  SIN_ARCHIVOS,
  FIRMANTE_VACIO,
  MONEDA_DEFAULT,
  TIENE_IVA_DEFAULT,
  NOMBRE_DATOS_BOM,
  pasos,
  EMPRESAS,
  formatearFechaLarga,
  formatearTamanio,
} from "./constantes";

export { pasos, PASO_BOM, NOMBRE_DATOS_BOM } from "./constantes";

const CreacionDocumentacion = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [vista, setVista] = useState("inicio");
  const [proyectos, setProyectos] = useState([]);
  const [proyectoActivoId, setProyectoActivoId] = useState(null);
  const [nombreNuevoProyecto, setNombreNuevoProyecto] = useState("");
  const [empresaNuevoProyecto, setEmpresaNuevoProyecto] = useState(EMPRESAS[0].id);
  const [diasLimiteNuevoProyecto, setDiasLimiteNuevoProyecto] = useState(DIAS_LIMITE_PROYECTO_DEFAULT);
  const [clienteIdNuevoProyecto, setClienteIdNuevoProyecto] = useState(null);
  const [creandoProyecto, setCreandoProyecto] = useState(false);
  const [cargandoProyectos, setCargandoProyectos] = useState(true);
  const [errorProyectos, setErrorProyectos] = useState("");

  const [clientes, setClientes] = useState([]);
  const [cargandoClientes, setCargandoClientes] = useState(true);
  const [errorClientes, setErrorClientes] = useState("");
  const [creandoClienteNuevo, setCreandoClienteNuevo] = useState(false);
  const [nombreNuevoCliente, setNombreNuevoCliente] = useState("");
  const [formularioClienteAbierto, setFormularioClienteAbierto] = useState(false);

  const [pasoActivo, setPasoActivo] = useState(1);
  const [archivosPorPaso, setArchivosPorPaso] = useState({});
  const [previewUrls, setPreviewUrls] = useState([]);
  const [generandoBOM, setGenerandoBOM] = useState(false);
  const [bomBlob, setBomBlob] = useState(null);
  const [errorBOM, setErrorBOM] = useState("");
  const [datosAssessment, setDatosAssessment] = useState(null);
  const [revisionAbierta, setRevisionAbierta] = useState(false);
  const [subiendoArchivo, setSubiendoArchivo] = useState(false);
  const [errorSubida, setErrorSubida] = useState("");
  const [cambiandoVersion, setCambiandoVersion] = useState(false);
  const [cargandoArchivosPaso, setCargandoArchivosPaso] = useState(false);
  const [versionSeleccionada, setVersionSeleccionada] = useState(1);
  const [archivosHistoricos, setArchivosHistoricos] = useState([]);
  const [cargandoHistorico, setCargandoHistorico] = useState(false);
  const [errorHistorico, setErrorHistorico] = useState("");

  const [firmante, setFirmante] = useState(FIRMANTE_VACIO);
  const [moneda, setMoneda] = useState(MONEDA_DEFAULT);
  const [tieneIVA, setTieneIVA] = useState(TIENE_IVA_DEFAULT);
  const [generandoPropuesta, setGenerandoPropuesta] = useState(false);
  const [propuestaBlob, setPropuestaBlob] = useState(null);
  const [errorPropuesta, setErrorPropuesta] = useState("");
  const [propuestaModalAbierta, setPropuestaModalAbierta] = useState(false);

  const [generandoEconomica, setGenerandoEconomica] = useState(false);
  const [economicaBlob, setEconomicaBlob] = useState(null);
  const [errorEconomica, setErrorEconomica] = useState("");
  const [economicaModalAbierta, setEconomicaModalAbierta] = useState(false);

  const [generandoKickoff, setGenerandoKickoff] = useState(false);
  const [kickoffBlob, setKickoffBlob] = useState(null);
  const [errorKickoff, setErrorKickoff] = useState("");
  const [origenSeleccionado, setOrigenSeleccionado] = useState({});
  const [versionOrigenBOMPendiente, setVersionOrigenBOMPendiente] = useState(null);
  const [archivosProyectoCompletado, setArchivosProyectoCompletado] = useState({});
  const [cargandoProyectoCompletado, setCargandoProyectoCompletado] = useState(false);
  const [errorProyectoCompletado, setErrorProyectoCompletado] = useState("");

  const archivos = archivosPorPaso[pasoActivo] || SIN_ARCHIVOS;
  const proyectoActivo = proyectos.find((p) => p.id === proyectoActivoId);
  const pasoActual = pasos.find((p) => p.numero === pasoActivo) || pasos[0];
  const versionActualPasoActivo = (proyectoActivo?.versionesPorPaso?.[pasoActivo]) || 1;
  const estaViendoVersionActual = versionSeleccionada === versionActualPasoActivo;
  const estaVersionFinalizada = (numeroPaso) => Boolean(proyectoActivo?.versionesFinales?.[numeroPaso]);
  const versionAssessmentActual = (proyectoActivo?.versionesPorPaso?.[PASO_ASSESSMENT]) || 1;
  const versionBOMActual = (proyectoActivo?.versionesPorPaso?.[PASO_BOM]) || 1;
  const versionOrigenBOM = origenSeleccionado[PASO_BOM] ?? versionAssessmentActual;
  const versionOrigenEconomica = origenSeleccionado[PASO_PROPUESTA_TECNICO_FUNCIONAL] ?? versionBOMActual;
  const versionOrigenPropuesta = origenSeleccionado[PASO_PROPUESTA_COMERCIAL] ?? versionBOMActual;
  const versionOrigenKickoff = origenSeleccionado[PASO_KICKOFF] ?? versionBOMActual;
  const proyectoCompletado = Boolean(proyectoActivo?.completado);

  useEffect(() => {
    let cancelado = false;
    setCargandoProyectos(true);
    setErrorProyectos("");
    listarProyectos()
      .then((lista) => {
        if (cancelado) return;
        setProyectos(
          lista.map((p) => ({ ...p, fechaCreacion: new Date(p.fechaCreacion) }))
        );
      })
      .catch((error) => {
        console.error(error);
        if (!cancelado) {
          setErrorProyectos(
            "No se pudieron cargar los proyectos guardados en S3. Intenta recargar la página."
          );
        }
      })
      .finally(() => {
        if (!cancelado) setCargandoProyectos(false);
      });
    return () => {
      cancelado = true;
    };
  }, []);

  useEffect(() => {
    let cancelado = false;
    setCargandoClientes(true);
    setErrorClientes("");
    listarClientes()
      .then((lista) => {
        if (cancelado) return;
        setClientes(
          lista.map((c) => ({ ...c, fechaCreacion: new Date(c.fechaCreacion) }))
        );
      })
      .catch((error) => {
        console.error(error);
        if (!cancelado) {
          setErrorClientes(
            "No se pudieron cargar los clientes guardados en S3. Intenta recargar la página."
          );
        }
      })
      .finally(() => {
        if (!cancelado) setCargandoClientes(false);
      });
    return () => {
      cancelado = true;
    };
  }, []);

  useEffect(() => {
    if (cargandoProyectos) return;
    const idSolicitado = searchParams.get("proyecto");
    if (!idSolicitado) return;
    if (proyectos.some((p) => p.id === idSolicitado) && idSolicitado !== proyectoActivoId) {
      seleccionarProyecto(idSolicitado);
    }
    setSearchParams({}, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, proyectos, cargandoProyectos]);

  useEffect(() => {
    const urls = archivos.map((file) => URL.createObjectURL(file));
    setPreviewUrls(urls);
    return () => {
      urls.forEach((url) => URL.revokeObjectURL(url));
    };
  }, [archivos]);

  useEffect(() => {
    if (vista !== "proyecto" || !proyectoActivo) return undefined;

    const numeroPaso = pasoActivo;
    const tituloPasoActual = (pasos.find((p) => p.numero === numeroPaso) || {}).titulo || "";
    const version = (proyectoActivo.versionesPorPaso && proyectoActivo.versionesPorPaso[numeroPaso]) || 1;
    let cancelado = false;

    setCargandoArchivosPaso(true);
    listarArchivosPaso({
      proyectoId: proyectoActivo.id,
      pasoNumero: numeroPaso,
      tituloPaso: tituloPasoActual,
      version,
    })
      .then(async (archivosGuardados) => {
        if (cancelado || archivosGuardados.length === 0) return;

        const cargados = archivosGuardados.filter((a) => a.tipo === "cargado");
        const generado = archivosGuardados.find((a) => a.tipo === "generado");

        if (cargados.length > 0 && (archivosPorPaso[numeroPaso] || []).length === 0) {
          const archivosRecuperados = await Promise.all(
            cargados.map(async (a) => {
              const blob = await descargarArchivoS3(a.key);
              return new File([blob], a.nombreArchivo, { type: blob.type });
            })
          );
          if (!cancelado) {
            setArchivosPorPaso((prev) =>
              (prev[numeroPaso] || []).length === 0
                ? { ...prev, [numeroPaso]: archivosRecuperados }
                : prev
            );
          }
        }

        const archivoVigente = cargados.length > 0 ? cargados[cargados.length - 1] : generado;

        if (numeroPaso === PASO_BOM && archivoVigente && !bomBlob) {
          const blobBOM = await descargarArchivoS3(archivoVigente.key);
          if (!cancelado) setBomBlob(blobBOM);
        }

        if (numeroPaso === PASO_PROPUESTA_TECNICO_FUNCIONAL && archivoVigente && !economicaBlob) {
          const blobEconomica = await descargarArchivoS3(archivoVigente.key);
          if (!cancelado) setEconomicaBlob(blobEconomica);
        }

        if (numeroPaso === PASO_PROPUESTA_COMERCIAL && archivoVigente && !propuestaBlob) {
          const blobPropuesta = await descargarArchivoS3(archivoVigente.key);
          if (!cancelado) setPropuestaBlob(blobPropuesta);
        }

        if (numeroPaso === PASO_KICKOFF && generado && !kickoffBlob) {
          const blobKickoff = await descargarArchivoS3(generado.key);
          if (!cancelado) setKickoffBlob(blobKickoff);
        }
      })
      .catch((error) => {
        console.error("No se pudieron recuperar los archivos guardados de este paso desde S3.", error);
      })
      .finally(() => {
        if (!cancelado) setCargandoArchivosPaso(false);
      });

    return () => {
      cancelado = true;
    };
  }, [proyectoActivoId, pasoActivo, vista]);

  useEffect(() => {
    if (vista !== "proyecto" || !proyectoActivo || estaViendoVersionActual) {
      setArchivosHistoricos([]);
      setErrorHistorico("");
      return undefined;
    }

    const tituloPasoSeleccionado = (pasos.find((p) => p.numero === pasoActivo) || {}).titulo || "";
    let cancelado = false;

    setCargandoHistorico(true);
    setErrorHistorico("");
    listarArchivosPaso({
      proyectoId: proyectoActivo.id,
      pasoNumero: pasoActivo,
      tituloPaso: tituloPasoSeleccionado,
      version: versionSeleccionada,
    })
      .then((lista) => {
        if (!cancelado) setArchivosHistoricos(lista);
      })
      .catch((error) => {
        console.error("No se pudieron recuperar los archivos de la versión seleccionada.", error);
        if (!cancelado) setErrorHistorico("No se pudieron cargar los archivos de esta versión.");
      })
      .finally(() => {
        if (!cancelado) setCargandoHistorico(false);
      });

    return () => {
      cancelado = true;
    };
  }, [proyectoActivoId, pasoActivo, vista, versionSeleccionada, estaViendoVersionActual]);

  useEffect(() => {
    if (!proyectoCompletado || !proyectoActivo) return undefined;
    let cancelado = false;

    setCargandoProyectoCompletado(true);
    setErrorProyectoCompletado("");
    Promise.all(
      pasos.map(async (paso) => {
        const version = (proyectoActivo.versionesPorPaso && proyectoActivo.versionesPorPaso[paso.numero]) || 1;
        const esFinal = Boolean(proyectoActivo.versionesFinales && proyectoActivo.versionesFinales[paso.numero]);
        try {
          const archivosPaso = await listarArchivosPaso({
            proyectoId: proyectoActivo.id,
            pasoNumero: paso.numero,
            tituloPaso: paso.titulo,
            version,
          });
          const generado = archivosPaso.find((a) => a.tipo === "generado");
          const cargados = archivosPaso.filter((a) => a.tipo === "cargado");
          const archivosDescarga = generado ? [generado] : cargados;
          return [paso.numero, { version, esFinal, archivos: archivosDescarga }];
        } catch (error) {
          console.error(`No se pudieron listar los archivos finales del paso ${paso.numero}.`, error);
          return [paso.numero, { version, esFinal, archivos: [] }];
        }
      })
    )
      .then((entradas) => {
        if (!cancelado) setArchivosProyectoCompletado(Object.fromEntries(entradas));
      })
      .catch((error) => {
        console.error("No se pudieron cargar los documentos finales del proyecto.", error);
        if (!cancelado) setErrorProyectoCompletado("No se pudieron cargar los documentos finales.");
      })
      .finally(() => {
        if (!cancelado) setCargandoProyectoCompletado(false);
      });

    return () => {
      cancelado = true;
    };
  }, [proyectoCompletado, proyectoActivoId]);

  const handleArchivoChange = async (event) => {
    const seleccionados = Array.from(event.target.files || []);
    event.target.value = "";
    if (seleccionados.length === 0) return;

    const multiple = esPasoMultiple(pasoActivo);
    const archivosASubir = multiple ? seleccionados : [seleccionados[0]];

    setArchivosPorPaso((prev) => {
      const actuales = prev[pasoActivo] || [];
      return {
        ...prev,
        [pasoActivo]: multiple ? [...actuales, ...archivosASubir] : archivosASubir,
      };
    });
    if (pasoActivo === PASO_ASSESSMENT) {
      setBomBlob(null);
      setErrorBOM("");
    }
    if (pasoActivo === PASO_BOM) {
      setBomBlob(archivosASubir[0]);
      setErrorBOM("");
    }
    if (pasoActivo === PASO_PROPUESTA_TECNICO_FUNCIONAL) {
      setEconomicaBlob(archivosASubir[0]);
      setErrorEconomica("");
    }
    if (pasoActivo === PASO_PROPUESTA_COMERCIAL) {
      setPropuestaBlob(archivosASubir[0]);
      setErrorPropuesta("");
    }
    setErrorSubida("");

    if (!proyectoActivo) return;

    setSubiendoArchivo(true);
    try {
      for (const file of archivosASubir) {
        await subirArchivoPaso({
          proyectoId: proyectoActivo.id,
          pasoNumero: pasoActivo,
          tituloPaso: pasoActual.titulo,
          version: (proyectoActivo.versionesPorPaso && proyectoActivo.versionesPorPaso[pasoActivo]) || 1,
          tipo: "cargado",
          archivo: file,
        });
      }
    } catch (error) {
      console.error("No se pudo guardar el archivo cargado en S3.", error);
      setErrorSubida(
        "No se pudo guardar el archivo en el histórico de S3 (se sigue usando localmente)."
      );
    } finally {
      setSubiendoArchivo(false);
    }
  };

  const quitarArchivo = (indice) => {
    setArchivosPorPaso((prev) => {
      const actuales = prev[pasoActivo] || [];
      return { ...prev, [pasoActivo]: actuales.filter((_, i) => i !== indice) };
    });
    if (pasoActivo === PASO_ASSESSMENT) {
      setBomBlob(null);
      setErrorBOM("");
    }
  };

  const abrirArchivoHistorico = async (archivo) => {
    try {
      const blob = await descargarArchivoS3(archivo.key);
      const nombreArchivo = archivo.nombreArchivo || "archivo";
      if (/\.(docx?|xlsx?|pptx?)$/i.test(nombreArchivo)) {
        saveAs(blob, nombreArchivo);
        return;
      }
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank", "noopener,noreferrer");
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (error) {
      console.error("No se pudo descargar el archivo de la versión seleccionada.", error);
      setErrorHistorico("No se pudo descargar este archivo.");
    }
  };

  const descargarArchivoFinal = async (archivo) => {
    try {
      const blob = await descargarArchivoS3(archivo.key);
      saveAs(blob, archivo.nombreArchivo || "archivo");
    } catch (error) {
      console.error("No se pudo descargar el archivo final.", error);
      setErrorProyectoCompletado("No se pudo descargar uno de los archivos finales.");
    }
  };

  const registrarProgresoProyecto = (numero) => {
    if (!proyectoActivo) return;
    const actualizado = {
      ...proyectoActivo,
      pasoMaximoAlcanzado: Math.max(proyectoActivo.pasoMaximoAlcanzado || 1, numero),
    };
    setProyectos((prev) => prev.map((p) => (p.id === actualizado.id ? actualizado : p)));
    guardarMetadataProyecto(actualizado).catch((error) =>
      console.error("No se pudo guardar el progreso del proyecto en S3.", error)
    );
  };

  const realizarCambioVersion = async () => {
    if (!proyectoActivo || estaVersionFinalizada(pasoActivo)) return;
    const versionActual =
      (proyectoActivo.versionesPorPaso && proyectoActivo.versionesPorPaso[pasoActivo]) || 1;
    const nuevaVersion = versionActual + 1;

    const actualizado = {
      ...proyectoActivo,
      versionesPorPaso: {
        ...(proyectoActivo.versionesPorPaso || {}),
        [pasoActivo]: nuevaVersion,
      },
    };

    setCambiandoVersion(true);
    setErrorSubida("");
    try {
      await guardarMetadataProyecto(actualizado);
      setProyectos((prev) => prev.map((p) => (p.id === actualizado.id ? actualizado : p)));
      setArchivosPorPaso((prev) => ({ ...prev, [pasoActivo]: [] }));
      if (pasoActivo === PASO_BOM) {
        setBomBlob(null);
        setErrorBOM("");
      }
      if (pasoActivo === PASO_PROPUESTA_TECNICO_FUNCIONAL) {
        setEconomicaBlob(null);
        setErrorEconomica("");
      }
      if (pasoActivo === PASO_PROPUESTA_COMERCIAL) {
        setPropuestaBlob(null);
        setErrorPropuesta("");
      }
      setVersionSeleccionada(nuevaVersion);
    } catch (error) {
      console.error("No se pudo iniciar una nueva versión.", error);
      setErrorSubida("No se pudo iniciar una nueva versión. Intenta de nuevo.");
    } finally {
      setCambiandoVersion(false);
    }
  };

  const marcarVersionComoFinal = async () => {
    if (!proyectoActivo) return;
    const version = (proyectoActivo.versionesPorPaso && proyectoActivo.versionesPorPaso[pasoActivo]) || 1;
    const confirmado = window.confirm(
      `¿Marcar la versión v${version} de "${pasoActual.titulo}" como final? Ya no podrás crear nuevas versiones de este paso.`
    );
    if (!confirmado) return;

    const actualizado = {
      ...proyectoActivo,
      versionesFinales: {
        ...(proyectoActivo.versionesFinales || {}),
        [pasoActivo]: true,
      },
    };

    try {
      await guardarMetadataProyecto(actualizado);
      setProyectos((prev) => prev.map((p) => (p.id === actualizado.id ? actualizado : p)));
    } catch (error) {
      console.error("No se pudo marcar la versión como final.", error);
      setErrorSubida("No se pudo marcar esta versión como final. Intenta de nuevo.");
    }
  };

  const extenderPlazoProyecto = async (diasAdicionales) => {
    if (!proyectoActivo || !diasAdicionales || diasAdicionales <= 0) return;

    const actualizado = {
      ...proyectoActivo,
      duracionDias: proyectoActivo.duracionDias + diasAdicionales,
      duracionDiasOriginal: proyectoActivo.duracionDiasOriginal ?? proyectoActivo.duracionDias,
      diasExtendidos: (proyectoActivo.diasExtendidos || 0) + diasAdicionales,
      fechaUltimaExtension: new Date().toISOString(),
    };

    try {
      await guardarMetadataProyecto(actualizado);
      setProyectos((prev) => prev.map((p) => (p.id === actualizado.id ? actualizado : p)));
    } catch (error) {
      console.error("No se pudo extender el plazo del proyecto.", error);
      window.alert("No se pudo guardar la extensión de plazo. Intenta de nuevo.");
    }
  };

  const finalizarProyecto = async () => {
    if (!proyectoActivo || !kickoffBlob) return;
    const confirmado = window.confirm(
      "¿Confirmar el proyecto? Se mostrará el resumen con los documentos finales de cada paso."
    );
    if (!confirmado) return;

    const actualizado = {
      ...proyectoActivo,
      completado: true,
      fechaCompletado: new Date().toISOString(),
    };

    try {
      await guardarMetadataProyecto(actualizado);
      setProyectos((prev) => prev.map((p) => (p.id === actualizado.id ? actualizado : p)));
    } catch (error) {
      console.error("No se pudo confirmar el proyecto.", error);
      window.alert("No se pudo guardar la confirmación del proyecto. Intenta de nuevo.");
    }
  };

  const irAPaso = (numero) => {
    if (pasoActivo > PASO_SIN_RETROCESO && numero < pasoActivo) return;
    setPasoActivo(numero);
    setVersionSeleccionada((proyectoActivo?.versionesPorPaso?.[numero]) || 1);
    registrarProgresoProyecto(numero);
  };

  const irAPasoAnterior = () => {
    if (pasoActivo > PASO_SIN_RETROCESO) return;
    const anterior = Math.max(1, pasoActivo - 1);
    setPasoActivo(anterior);
    setVersionSeleccionada((proyectoActivo?.versionesPorPaso?.[anterior]) || 1);
  };

  const irAPasoSiguiente = () => {
    const siguiente = Math.min(pasos.length, pasoActivo + 1);
    setPasoActivo(siguiente);
    setVersionSeleccionada((proyectoActivo?.versionesPorPaso?.[siguiente]) || 1);
    registrarProgresoProyecto(siguiente);
  };

  const obtenerArchivoAssessmentDeVersion = async (version) => {
    if (!proyectoActivo) return null;

    if (version === versionAssessmentActual) {
      const local = (archivosPorPaso[PASO_ASSESSMENT] || []).find((file) => /\.docx?$/i.test(file.name));
      if (local) return local;
    }

    try {
      const archivosGuardados = await listarArchivosPaso({
        proyectoId: proyectoActivo.id,
        pasoNumero: PASO_ASSESSMENT,
        tituloPaso: pasos.find((p) => p.numero === PASO_ASSESSMENT).titulo,
        version,
      });
      const cargadoDocx = archivosGuardados.find(
        (a) => a.tipo === "cargado" && /\.docx?$/i.test(a.nombreArchivo)
      );
      if (!cargadoDocx) return null;
      const blob = await descargarArchivoS3(cargadoDocx.key);
      return new File([blob], cargadoDocx.nombreArchivo, { type: blob.type });
    } catch (error) {
      console.error(`No se pudo recuperar el Assessment v${version} desde S3.`, error);
      return null;
    }
  };

  const guardarDatosBOM = async (version, datos) => {
    if (!proyectoActivo) return;
    const blobDatos = new Blob([JSON.stringify(datos)], { type: "application/json" });
    await subirArchivoPaso({
      proyectoId: proyectoActivo.id,
      pasoNumero: PASO_BOM,
      tituloPaso: pasos.find((p) => p.numero === PASO_BOM).titulo,
      version,
      tipo: "datos",
      archivo: blobDatos,
      nombreArchivo: NOMBRE_DATOS_BOM,
    });
  };

  const obtenerDatosBOMDeVersion = async (version) => {
    if (!proyectoActivo) return null;
    try {
      const archivosGuardados = await listarArchivosPaso({
        proyectoId: proyectoActivo.id,
        pasoNumero: PASO_BOM,
        tituloPaso: pasos.find((p) => p.numero === PASO_BOM).titulo,
        version,
      });
      const datosArchivo = archivosGuardados.find(
        (a) => a.tipo === "datos" && a.nombreArchivo === NOMBRE_DATOS_BOM
      );
      if (!datosArchivo) return null;
      const blob = await descargarArchivoS3(datosArchivo.key);
      const texto = await blob.text();
      return JSON.parse(texto);
    } catch (error) {
      console.error(`No se pudieron recuperar los datos del BOM v${version} desde S3.`, error);
      return null;
    }
  };

  const generarBOMDesdeVersionAssessment = async (versionAssessment) => {
    setGenerandoBOM(true);
    setErrorBOM("");
    try {
      const archivoAssessmentDocx = await obtenerArchivoAssessmentDeVersion(versionAssessment);
      if (!archivoAssessmentDocx) {
        throw new Error(
          `No se encontró un Assessment en Word (.docx) guardado para la versión v${versionAssessment}.`
        );
      }
      const datos = await extraerDatosAssessment(archivoAssessmentDocx);
      setDatosAssessment(datos);
      setVersionOrigenBOMPendiente(versionAssessment);
      setRevisionAbierta(true);
    } catch (error) {
      console.error(error);
      setErrorBOM(
        error.message || "No se pudo generar el BOM a partir del Assessment."
      );
      setGenerandoBOM(false);
    }
  };

  const avanzarPaso = async () => {
    const archivosAssessment = archivosPorPaso[PASO_ASSESSMENT] || SIN_ARCHIVOS;
    const debeGenerarBOM = pasoActivo === PASO_ASSESSMENT && archivosAssessment.length > 0 && !bomBlob;

    if (!debeGenerarBOM) {
      irAPasoSiguiente();
      return;
    }

    await generarBOMDesdeVersionAssessment(versionAssessmentActual);
  };

  const confirmarRevisionOrtografica = async (datosCorregidos) => {
    setRevisionAbierta(false);
    const versionBOMDestino = (proyectoActivo?.versionesPorPaso?.[PASO_BOM]) || 1;
    const versionAssessmentUsada = versionOrigenBOMPendiente || versionAssessmentActual;
    const pasoDeOrigen = pasoActivo;
    try {
      const { logoCliente, nombreProyecto, ...secciones } = datosCorregidos;
      const nombreFinal = proyectoActivo ? proyectoActivo.nombre : "Proyecto";
      const blob = await generarDocumentoBOM({
        nombreProyecto: nombreFinal,
        fechaCreacion: formatearFechaLarga(new Date()),
        logoCliente,
        empresa: proyectoActivo ? proyectoActivo.empresa : EMPRESAS[0].id,
        secciones,
      });
      setBomBlob(blob);

      if (proyectoActivo) {
        try {
          await subirArchivoPaso({
            proyectoId: proyectoActivo.id,
            pasoNumero: PASO_BOM,
            tituloPaso: pasos.find((p) => p.numero === PASO_BOM).titulo,
            version: versionBOMDestino,
            tipo: "generado",
            archivo: blob,
            nombreArchivo: `BOM_${nombreFinal.replace(/\s+/g, "_")}.docx`,
          });
          await guardarDatosBOM(versionBOMDestino, datosCorregidos);

          const actualizado = {
            ...proyectoActivo,
            origenVersionPorPaso: {
              ...(proyectoActivo.origenVersionPorPaso || {}),
              [PASO_BOM]: versionAssessmentUsada,
            },
          };
          await guardarMetadataProyecto(actualizado);
          setProyectos((prev) => prev.map((p) => (p.id === actualizado.id ? actualizado : p)));
        } catch (errorSubidaBOM) {
          console.error("No se pudo guardar el BOM generado en S3.", errorSubidaBOM);
        }
      }
    } catch (error) {
      console.error(error);
      setErrorBOM(
        error.message || "No se pudo generar el BOM a partir del Assessment."
      );
    } finally {
      setGenerandoBOM(false);
      setDatosAssessment(null);
      setVersionOrigenBOMPendiente(null);
      if (pasoDeOrigen === PASO_ASSESSMENT) irAPasoSiguiente();
    }
  };

  const cancelarRevisionOrtografica = () => {
    setRevisionAbierta(false);
    setDatosAssessment(null);
    setVersionOrigenBOMPendiente(null);
    setGenerandoBOM(false);
  };

  const descargarBOM = () => {
    if (!bomBlob) return;
    const nombreArchivo = `BOM_${(proyectoActivo ? proyectoActivo.nombre : "Proyecto").replace(/\s+/g, "_")}.docx`;
    saveAs(bomBlob, nombreArchivo);
  };

  const obtenerDatosClienteDesdeBOM = async (version) => {
    const vacio = { logoCliente: null, contacto: "", puestoContacto: "" };
    const datos = await obtenerDatosBOMDeVersion(version);
    if (!datos) return vacio;
    return {
      logoCliente: datos.logoCliente || null,
      contacto: datos.contacto || "",
      puestoContacto: datos.puestoContacto || "",
    };
  };

  const firmanteCompleto = firmante.nombre.trim() && firmante.puesto.trim() && firmante.correo.trim() && firmante.celular.trim();

  const generarPropuestaComercial = async () => {
    if (!proyectoActivo || !firmanteCompleto) return false;

    setGenerandoPropuesta(true);
    setErrorPropuesta("");
    try {
      const clienteDelProyecto = clientes.find((c) => c.id === proyectoActivo.clienteId);
      const nombreCliente = clienteDelProyecto ? clienteDelProyecto.nombre : "Cliente";
      const { logoCliente, contacto, puestoContacto } = await obtenerDatosClienteDesdeBOM(versionOrigenPropuesta);
      const blob = await generarDocumentoPropuestaComercial({
        nombreProyecto: proyectoActivo.nombre,
        fechaCreacion: formatearFechaLarga(new Date()),
        nombreCliente,
        contactoCliente: contacto,
        puestoContactoCliente: puestoContacto,
        logoCliente,
        empresa: proyectoActivo.empresa,
        firmante,
        moneda,
      });
      setPropuestaBlob(blob);

      const actualizado = {
        ...proyectoActivo,
        firmante,
        moneda,
        origenVersionPorPaso: {
          ...(proyectoActivo.origenVersionPorPaso || {}),
          [PASO_PROPUESTA_COMERCIAL]: versionOrigenPropuesta,
        },
      };
      try {
        await guardarMetadataProyecto(actualizado);
        setProyectos((prev) => prev.map((p) => (p.id === actualizado.id ? actualizado : p)));
      } catch (errorMetadata) {
        console.error("No se pudo guardar el firmante en la metadata del proyecto.", errorMetadata);
      }

      try {
        await subirArchivoPaso({
          proyectoId: proyectoActivo.id,
          pasoNumero: PASO_PROPUESTA_COMERCIAL,
          tituloPaso: pasos.find((p) => p.numero === PASO_PROPUESTA_COMERCIAL).titulo,
          version: (proyectoActivo.versionesPorPaso && proyectoActivo.versionesPorPaso[PASO_PROPUESTA_COMERCIAL]) || 1,
          tipo: "generado",
          archivo: blob,
          nombreArchivo: `Propuesta_Comercial_${proyectoActivo.nombre.replace(/\s+/g, "_")}.docx`,
        });
      } catch (errorSubidaPropuesta) {
        console.error("No se pudo guardar la Propuesta Comercial generada en S3.", errorSubidaPropuesta);
      }
      return true;
    } catch (error) {
      console.error(error);
      setErrorPropuesta(error.message || "No se pudo generar la Propuesta Comercial.");
      return false;
    } finally {
      setGenerandoPropuesta(false);
    }
  };

  const confirmarGenerarPropuestaDesdeModal = async () => {
    const exito = await generarPropuestaComercial();
    if (exito) setPropuestaModalAbierta(false);
  };

  const descargarPropuesta = () => {
    if (!propuestaBlob) return;
    const nombreArchivo = `Propuesta_Comercial_${(proyectoActivo ? proyectoActivo.nombre : "Proyecto").replace(
      /\s+/g,
      "_"
    )}.docx`;
    saveAs(propuestaBlob, nombreArchivo);
  };

  const generarPropuestaEconomica = async () => {
    if (!proyectoActivo || !firmanteCompleto) return false;

    setGenerandoEconomica(true);
    setErrorEconomica("");
    try {
      const datosBOM = await obtenerDatosBOMDeVersion(versionOrigenEconomica);
      const blob = await generarDocumentoPropuestaEconomica({
        nombreProyecto: proyectoActivo.nombre,
        fechaCreacion: formatearFechaLarga(new Date()),
        nombreRazonSocial: datosBOM ? datosBOM.nombreRazonSocial : "",
        contactoCliente: datosBOM ? datosBOM.contacto : "",
        puestoContactoCliente: datosBOM ? datosBOM.puestoContacto : "",
        logoCliente: datosBOM ? datosBOM.logoCliente : null,
        empresa: proyectoActivo.empresa,
        bomFilas: datosBOM ? datosBOM.bomFilas : [],
        marcasCronograma: datosBOM || {},
        tieneBom: datosBOM ? Boolean(datosBOM.tieneBom) : false,
        tieneCronograma: datosBOM ? Boolean(datosBOM.tieneCronograma) : false,
        firmante,
        moneda,
        tieneIVA,
      });
      setEconomicaBlob(blob);

      const actualizado = {
        ...proyectoActivo,
        firmante,
        moneda,
        tieneIVA,
        origenVersionPorPaso: {
          ...(proyectoActivo.origenVersionPorPaso || {}),
          [PASO_PROPUESTA_TECNICO_FUNCIONAL]: versionOrigenEconomica,
        },
      };
      try {
        await guardarMetadataProyecto(actualizado);
        setProyectos((prev) => prev.map((p) => (p.id === actualizado.id ? actualizado : p)));
      } catch (errorMetadata) {
        console.error(
          "No se pudo guardar los datos de la Propuesta Económica en la metadata del proyecto.",
          errorMetadata
        );
      }

      try {
        await subirArchivoPaso({
          proyectoId: proyectoActivo.id,
          pasoNumero: PASO_PROPUESTA_TECNICO_FUNCIONAL,
          tituloPaso: pasos.find((p) => p.numero === PASO_PROPUESTA_TECNICO_FUNCIONAL).titulo,
          version:
            (proyectoActivo.versionesPorPaso &&
              proyectoActivo.versionesPorPaso[PASO_PROPUESTA_TECNICO_FUNCIONAL]) ||
            1,
          tipo: "generado",
          archivo: blob,
          nombreArchivo: `Propuesta_Economica_${proyectoActivo.nombre.replace(/\s+/g, "_")}.docx`,
        });
      } catch (errorSubidaEconomica) {
        console.error("No se pudo guardar la Propuesta Económica generada en S3.", errorSubidaEconomica);
      }
      return true;
    } catch (error) {
      console.error(error);
      setErrorEconomica(error.message || "No se pudo generar la Propuesta Económica.");
      return false;
    } finally {
      setGenerandoEconomica(false);
    }
  };

  const confirmarGenerarEconomicaDesdeModal = async () => {
    const exito = await generarPropuestaEconomica();
    if (exito) setEconomicaModalAbierta(false);
  };

  const descargarEconomica = () => {
    if (!economicaBlob) return;
    const nombreArchivo = `Propuesta_Economica_${(proyectoActivo ? proyectoActivo.nombre : "Proyecto").replace(
      /\s+/g,
      "_"
    )}.docx`;
    saveAs(economicaBlob, nombreArchivo);
  };

  const generarKickoff = async () => {
    if (!proyectoActivo) return;

    setGenerandoKickoff(true);
    setErrorKickoff("");
    try {
      const datosBOM = await obtenerDatosBOMDeVersion(versionOrigenKickoff);

      const blob = await generarDocumentoKickoff({
        nombreProyecto: proyectoActivo.nombre,
        bomIntro: datosBOM ? datosBOM.bomIntro : "",
        logoCliente: datosBOM ? datosBOM.logoCliente : null,
        empresa: proyectoActivo.empresa,
        objetivoItems: datosBOM ? datosBOM.objetivoItems : [],
        bomFilas: datosBOM ? datosBOM.bomFilas : [],
        marcasCronograma: datosBOM || {},
        tieneObjetivo: datosBOM ? Boolean(datosBOM.tieneObjetivo) : false,
        tieneBom: datosBOM ? Boolean(datosBOM.tieneBom) : false,
        tieneCronograma: datosBOM ? Boolean(datosBOM.tieneCronograma) : false,
      });
      setKickoffBlob(blob);

      const actualizado = {
        ...proyectoActivo,
        origenVersionPorPaso: {
          ...(proyectoActivo.origenVersionPorPaso || {}),
          [PASO_KICKOFF]: versionOrigenKickoff,
        },
      };
      try {
        await guardarMetadataProyecto(actualizado);
        setProyectos((prev) => prev.map((p) => (p.id === actualizado.id ? actualizado : p)));
      } catch (errorMetadata) {
        console.error("No se pudo guardar el origen de versión del Kick-off.", errorMetadata);
      }

      try {
        await subirArchivoPaso({
          proyectoId: proyectoActivo.id,
          pasoNumero: PASO_KICKOFF,
          tituloPaso: pasos.find((p) => p.numero === PASO_KICKOFF).titulo,
          version: (proyectoActivo.versionesPorPaso && proyectoActivo.versionesPorPaso[PASO_KICKOFF]) || 1,
          tipo: "generado",
          archivo: blob,
          nombreArchivo: `Kickoff_${proyectoActivo.nombre.replace(/\s+/g, "_")}.pptx`,
        });
      } catch (errorSubidaKickoff) {
        console.error("No se pudo guardar el Kick-off generado en S3.", errorSubidaKickoff);
      }
    } catch (error) {
      console.error(error);
      setErrorKickoff(error.message || "No se pudo generar el Kick-off.");
    } finally {
      setGenerandoKickoff(false);
    }
  };

  const descargarKickoff = () => {
    if (!kickoffBlob) return;
    const nombreArchivo = `Kickoff_${(proyectoActivo ? proyectoActivo.nombre : "Proyecto").replace(
      /\s+/g,
      "_"
    )}.pptx`;
    saveAs(kickoffBlob, nombreArchivo);
  };

  const iniciarCreacionProyecto = (clienteId) => {
    setClienteIdNuevoProyecto(clienteId);
    setNombreNuevoProyecto(`Proyecto ${proyectos.length + 1}`);
    setEmpresaNuevoProyecto(EMPRESAS[0].id);
    setDiasLimiteNuevoProyecto(DIAS_LIMITE_PROYECTO_DEFAULT);
    setErrorProyectos("");
    setVista("nombrando");
  };

  const clienteNuevoProyecto = clientes.find((c) => c.id === clienteIdNuevoProyecto);

  const confirmarCreacionProyecto = async (event) => {
    event.preventDefault();
    const nombre = nombreNuevoProyecto.trim() || "Proyecto sin nombre";
    const duracionDias = Math.max(1, Number(diasLimiteNuevoProyecto) || DIAS_LIMITE_PROYECTO_DEFAULT);
    const nuevoProyecto = {
      id: generarSlugProyecto(nombre),
      nombre,
      empresa: empresaNuevoProyecto,
      clienteId: clienteIdNuevoProyecto,
      fechaCreacion: new Date(),
      duracionDias,
      pasoMaximoAlcanzado: 1,
      versionesPorPaso: Object.fromEntries(pasos.map((p) => [p.numero, 1])),
      versionesFinales: {},
      origenVersionPorPaso: {},
    };

    setCreandoProyecto(true);
    setErrorProyectos("");
    try {
      await guardarMetadataProyecto(nuevoProyecto);
      setProyectos((prev) => [nuevoProyecto, ...prev]);
      setProyectoActivoId(nuevoProyecto.id);
      setNombreNuevoProyecto("");
      setPasoActivo(1);
      setVersionSeleccionada(1);
      setArchivosPorPaso({});
      setBomBlob(null);
      setErrorBOM("");
      setEconomicaBlob(null);
      setErrorEconomica("");
      setPropuestaBlob(null);
      setErrorPropuesta("");
      setFirmante(FIRMANTE_VACIO);
      setMoneda(MONEDA_DEFAULT);
      setTieneIVA(TIENE_IVA_DEFAULT);
      setKickoffBlob(null);
      setErrorKickoff("");
      setVista("proyecto");
    } catch (error) {
      console.error("No se pudo guardar el proyecto nuevo en S3.", error);
      setErrorProyectos("No se pudo guardar el proyecto nuevo en S3. Intenta de nuevo.");
    } finally {
      setCreandoProyecto(false);
    }
  };

  const cancelarCreacionProyecto = () => {
    setNombreNuevoProyecto("");
    setVista(proyectos.length > 0 ? "proyecto" : "inicio");
  };

  const seleccionarProyecto = (id) => {
    const proyecto = proyectos.find((p) => p.id === id);
    const pasoInicial = proyecto ? proyecto.pasoMaximoAlcanzado || 1 : 1;
    setProyectoActivoId(id);
    setPasoActivo(pasoInicial);
    setVersionSeleccionada((proyecto?.versionesPorPaso?.[pasoInicial]) || 1);
    setArchivosPorPaso({});
    setBomBlob(null);
    setErrorBOM("");
    setEconomicaBlob(null);
    setErrorEconomica("");
    setPropuestaBlob(null);
    setErrorPropuesta("");
    setFirmante((proyecto && proyecto.firmante) || FIRMANTE_VACIO);
    setMoneda((proyecto && proyecto.moneda) || MONEDA_DEFAULT);
    setTieneIVA((proyecto && proyecto.tieneIVA) ?? TIENE_IVA_DEFAULT);
    setKickoffBlob(null);
    setErrorKickoff("");
    setVista("proyecto");
  };

  const eliminarProyecto = async (id, event) => {
    event.stopPropagation();
    const proyecto = proyectos.find((p) => p.id === id);
    if (!proyecto) return;

    const confirmado = window.confirm(
      `¿Eliminar el proyecto "${proyecto.nombre}"? Esta acción no se puede deshacer y borrará todos sus archivos guardados en S3.`
    );
    if (!confirmado) return;

    const restantes = proyectos.filter((p) => p.id !== id);
    setProyectos(restantes);

    if (id === proyectoActivoId) {
      if (restantes.length > 0) {
        const pasoInicialRestante = restantes[0].pasoMaximoAlcanzado || 1;
        setProyectoActivoId(restantes[0].id);
        setPasoActivo(pasoInicialRestante);
        setVersionSeleccionada((restantes[0].versionesPorPaso?.[pasoInicialRestante]) || 1);
        setArchivosPorPaso({});
        setBomBlob(null);
        setErrorBOM("");
        setEconomicaBlob(null);
        setErrorEconomica("");
        setPropuestaBlob(null);
        setErrorPropuesta("");
        setFirmante(restantes[0].firmante || FIRMANTE_VACIO);
        setMoneda(restantes[0].moneda || MONEDA_DEFAULT);
        setTieneIVA(restantes[0].tieneIVA ?? TIENE_IVA_DEFAULT);
        setKickoffBlob(null);
        setErrorKickoff("");
        setVista("proyecto");
      } else {
        setProyectoActivoId(null);
        setVista("inicio");
      }
    }

    try {
      await eliminarProyectoS3(id);
    } catch (error) {
      console.error("No se pudo eliminar el proyecto de S3.", error);
    }
  };

  const iniciarCreacionCliente = () => {
    setNombreNuevoCliente("");
    setErrorClientes("");
    setFormularioClienteAbierto(true);
  };

  const cancelarCreacionCliente = () => {
    setNombreNuevoCliente("");
    setFormularioClienteAbierto(false);
  };

  const confirmarCreacionCliente = async (event) => {
    event.preventDefault();
    const nombre = nombreNuevoCliente.trim();
    if (!nombre) return;

    const nuevoCliente = {
      id: generarSlugCliente(nombre),
      nombre,
      fechaCreacion: new Date(),
    };

    setCreandoClienteNuevo(true);
    setErrorClientes("");
    try {
      await guardarMetadataCliente(nuevoCliente);
      setClientes((prev) => [nuevoCliente, ...prev]);
      setNombreNuevoCliente("");
      setFormularioClienteAbierto(false);
    } catch (error) {
      console.error("No se pudo guardar el cliente nuevo en S3.", error);
      setErrorClientes("No se pudo guardar el cliente nuevo en S3. Intenta de nuevo.");
    } finally {
      setCreandoClienteNuevo(false);
    }
  };

  const eliminarCliente = async (id, event) => {
    event.stopPropagation();
    const datosCliente = clientes.find((c) => c.id === id);
    if (!datosCliente) return;

    const tieneProyectos = proyectos.some((p) => p.clienteId === id);
    if (tieneProyectos) {
      window.alert(
        `No se puede eliminar "${datosCliente.nombre}" porque todavía tiene proyectos asociados. Elimina o reasigna sus proyectos primero.`
      );
      return;
    }

    const confirmado = window.confirm(
      `¿Eliminar el cliente "${datosCliente.nombre}"? Esta acción no se puede deshacer.`
    );
    if (!confirmado) return;

    setClientes((prev) => prev.filter((c) => c.id !== id));

    try {
      await eliminarClienteS3(id);
    } catch (error) {
      console.error("No se pudo eliminar el cliente de S3.", error);
    }
  };

  const proyectosSinCliente = proyectos.filter(
    (p) => !p.clienteId || !clientes.some((c) => c.id === p.clienteId)
  );
  const versionActivaFinalizada = estaVersionFinalizada(pasoActivo);

  const hayContenidoPasoActivo =
    archivos.length > 0 ||
    (pasoActivo === PASO_BOM && Boolean(bomBlob)) ||
    (pasoActivo === PASO_PROPUESTA_TECNICO_FUNCIONAL && Boolean(economicaBlob)) ||
    (pasoActivo === PASO_PROPUESTA_COMERCIAL && Boolean(propuestaBlob));
  const mostrarBotonVersion =
    pasoActual.numero <= PASO_MAX_VERSIONABLE &&
    hayContenidoPasoActivo &&
    estaViendoVersionActual &&
    !versionActivaFinalizada;
  const mostrarBotonFinal = mostrarBotonVersion;

  const esPasoGeneradoDesdeMachote = PASOS_GENERADOS_DESDE_MACHOTE.includes(pasoActual.numero);
  const mostrarZonaCarga =
    !esPasoGeneradoDesdeMachote || (versionActualPasoActivo > 1 && !hayContenidoPasoActivo);

  return (
    <>
      <Container fluid className="background-containerr">
        {vista === "inicio" && (
          <div className="orgproc-header">
            <h1 className="orgproc-heading">Creación de Documentación</h1>
          </div>
        )}

        {vista === "inicio" && (
          <div className="docgen-landing">
            {(cargandoProyectos || cargandoClientes) && (
              <p className="docgen-landing-estado">Cargando clientes y proyectos guardados...</p>
            )}

            {!cargandoClientes && errorClientes && (
              <p className="docgen-landing-estado docgen-landing-estado--error">
                {errorClientes}
              </p>
            )}

            {!cargandoProyectos && errorProyectos && (
              <p className="docgen-landing-estado docgen-landing-estado--error">
                {errorProyectos}
              </p>
            )}

            {formularioClienteAbierto ? (
              <form className="docgen-cliente-form" onSubmit={confirmarCreacionCliente}>
                <input
                  type="text"
                  className="docgen-name-input"
                  value={nombreNuevoCliente}
                  onChange={(event) => setNombreNuevoCliente(event.target.value)}
                  placeholder="Nombre del cliente"
                  autoFocus
                  maxLength={80}
                />
                <div className="docgen-card-actions">
                  <button
                    type="submit"
                    className="orgproc-card-btn"
                    disabled={!nombreNuevoCliente.trim() || creandoClienteNuevo}
                  >
                    {creandoClienteNuevo ? "Guardando..." : "Crear cliente →"}
                  </button>
                  <button
                    type="button"
                    className="docgen-cancel-btn"
                    onClick={cancelarCreacionCliente}
                    disabled={creandoClienteNuevo}
                  >
                    Cancelar
                  </button>
                </div>
              </form>
            ) : (
              <button
                type="button"
                className="docgen-landing-btn"
                onClick={iniciarCreacionCliente}
              >
                <span className="docgen-landing-icon">+</span>
                Crear nuevo cliente
              </button>
            )}

            {!cargandoClientes && clientes.length > 0 && (
              <div className="docgen-landing-lista">
                {clientes.map((datosCliente) => {
                  const proyectosCliente = proyectos.filter(
                    (p) => p.clienteId === datosCliente.id
                  );
                  return (
                    <div key={datosCliente.id} className="docgen-landing-cliente-grupo">
                      <div className="docgen-landing-lista-titulo docgen-landing-lista-titulo--cliente">
                        {datosCliente.nombre} ({proyectosCliente.length})
                        <button
                          type="button"
                          className="docgen-landing-cliente-add"
                          onClick={() => iniciarCreacionProyecto(datosCliente.id)}
                          title={`Nuevo proyecto para ${datosCliente.nombre}`}
                        >
                          + Proyecto
                        </button>
                      </div>
                      {proyectosCliente.length > 0 && (
                        <div className="docgen-landing-grid">
                          {proyectosCliente.map((proyecto) => (
                            <button
                              key={proyecto.id}
                              type="button"
                              className="docgen-landing-card"
                              onClick={() => seleccionarProyecto(proyecto.id)}
                            >
                              <span className="docgen-landing-card-icono">📁</span>
                              <span className="docgen-landing-card-nombre">
                                {proyecto.nombre}
                              </span>
                              <span className="docgen-landing-card-paso">
                                Paso {proyecto.pasoMaximoAlcanzado || 1} de {pasos.length}
                              </span>
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}

            {!cargandoProyectos && proyectosSinCliente.length > 0 && (
              <div className="docgen-landing-lista">
                <div className="docgen-landing-lista-titulo">
                  Sin cliente ({proyectosSinCliente.length})
                </div>
                <div className="docgen-landing-grid">
                  {proyectosSinCliente.map((proyecto) => (
                    <button
                      key={proyecto.id}
                      type="button"
                      className="docgen-landing-card"
                      onClick={() => seleccionarProyecto(proyecto.id)}
                    >
                      <span className="docgen-landing-card-icono">📁</span>
                      <span className="docgen-landing-card-nombre">
                        {proyecto.nombre}
                      </span>
                      <span className="docgen-landing-card-paso">
                        Paso {proyecto.pasoMaximoAlcanzado || 1} de {pasos.length}
                      </span>
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}

        {(vista === "proyecto" || vista === "nombrando") && (
          <div className="docgen-layout">
            <aside className="docgen-sidebar">
              <div className="docgen-sidebar-header">Clientes</div>

              {formularioClienteAbierto ? (
                <form className="docgen-cliente-form" onSubmit={confirmarCreacionCliente}>
                  <input
                    type="text"
                    className="docgen-name-input"
                    value={nombreNuevoCliente}
                    onChange={(event) => setNombreNuevoCliente(event.target.value)}
                    placeholder="Nombre del cliente"
                    autoFocus
                    maxLength={80}
                  />
                  <div className="docgen-card-actions">
                    <button
                      type="submit"
                      className="orgproc-card-btn"
                      disabled={!nombreNuevoCliente.trim() || creandoClienteNuevo}
                    >
                      {creandoClienteNuevo ? "Guardando..." : "Crear →"}
                    </button>
                    <button
                      type="button"
                      className="docgen-cancel-btn"
                      onClick={cancelarCreacionCliente}
                      disabled={creandoClienteNuevo}
                    >
                      Cancelar
                    </button>
                  </div>
                </form>
              ) : (
                <button
                  type="button"
                  className="docgen-sidebar-new-btn"
                  onClick={iniciarCreacionCliente}
                >
                  <span className="docgen-sidebar-new-icon">+</span>
                  Nuevo cliente
                </button>
              )}

              {errorClientes && (
                <p className="docgen-output-hint docgen-output-hint--error">{errorClientes}</p>
              )}

              <div className="docgen-folder-list">
                {clientes.map((datosCliente) => {
                  const proyectosCliente = proyectos.filter(
                    (p) => p.clienteId === datosCliente.id
                  );
                  return (
                    <div key={datosCliente.id} className="docgen-client-group">
                      <div className="docgen-client-item">
                        <span className="docgen-folder-icon">🏢</span>
                        <span className="docgen-client-name" title={datosCliente.nombre}>
                          {datosCliente.nombre}
                        </span>
                        <button
                          type="button"
                          className="docgen-client-add"
                          onClick={() => iniciarCreacionProyecto(datosCliente.id)}
                          aria-label={`Nuevo proyecto para ${datosCliente.nombre}`}
                          title="Nuevo proyecto para este cliente"
                        >
                          +
                        </button>
                        <button
                          type="button"
                          className="docgen-folder-delete"
                          onClick={(event) => eliminarCliente(datosCliente.id, event)}
                          aria-label={`Eliminar ${datosCliente.nombre}`}
                          title="Eliminar cliente"
                        >
                          🗑
                        </button>
                      </div>

                      <div className="docgen-client-proyectos">
                        {proyectosCliente.map((proyecto) => (
                          <div
                            key={proyecto.id}
                            className={
                              "docgen-folder-item" +
                              (proyecto.id === proyectoActivoId && vista === "proyecto"
                                ? " docgen-folder-item--active"
                                : "")
                            }
                          >
                            <button
                              type="button"
                              className="docgen-folder-select"
                              onClick={() => seleccionarProyecto(proyecto.id)}
                            >
                              <span className="docgen-folder-icon">📁</span>
                              <span className="docgen-folder-name" title={proyecto.nombre}>
                                {proyecto.nombre}
                              </span>
                            </button>
                            <button
                              type="button"
                              className="docgen-folder-delete"
                              onClick={(event) => eliminarProyecto(proyecto.id, event)}
                              aria-label={`Eliminar ${proyecto.nombre}`}
                              title="Eliminar proyecto"
                            >
                              🗑
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>

              {proyectosSinCliente.length > 0 && (
                <div className="docgen-client-group">
                  <div className="docgen-client-item docgen-client-item--sin-cliente">
                    <span className="docgen-folder-icon">🏢</span>
                    <span className="docgen-client-name">Sin cliente</span>
                  </div>
                  <div className="docgen-client-proyectos">
                    {proyectosSinCliente.map((proyecto) => (
                      <div
                        key={proyecto.id}
                        className={
                          "docgen-folder-item" +
                          (proyecto.id === proyectoActivoId && vista === "proyecto"
                            ? " docgen-folder-item--active"
                            : "")
                        }
                      >
                        <button
                          type="button"
                          className="docgen-folder-select"
                          onClick={() => seleccionarProyecto(proyecto.id)}
                        >
                          <span className="docgen-folder-icon">📁</span>
                          <span className="docgen-folder-name" title={proyecto.nombre}>
                            {proyecto.nombre}
                          </span>
                        </button>
                        <button
                          type="button"
                          className="docgen-folder-delete"
                          onClick={(event) => eliminarProyecto(proyecto.id, event)}
                          aria-label={`Eliminar ${proyecto.nombre}`}
                          title="Eliminar proyecto"
                        >
                          🗑
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </aside>

            {vista === "nombrando" && (
              <div className="docgen-main">
                <div className="orgproc-header">
                  <h1 className="orgproc-heading">Creación de Documentación</h1>
                </div>

                <div className="docgen-grid">
                  <div className="orgproc-card">
                    <div className="orgproc-card-accent"></div>
                    <div className="orgproc-card-body">
                      <div className="orgproc-eyebrow">
                        Nuevo proyecto{clienteNuevoProyecto ? ` · ${clienteNuevoProyecto.nombre}` : ""}
                      </div>
                      <div className="orgproc-card-title">
                        Nombre del proyecto
                      </div>
                      <p className="orgproc-card-desc">
                        Este nombre identificará al proyecto en toda la
                        documentación generada y no podrá modificarse una
                        vez creado.
                      </p>
                      <form onSubmit={confirmarCreacionProyecto}>
                        <input
                          type="text"
                          className="docgen-name-input"
                          value={nombreNuevoProyecto}
                          onChange={(event) =>
                            setNombreNuevoProyecto(event.target.value)
                          }
                          autoFocus
                          maxLength={80}
                        />

                        <div className="docgen-empresa-label">Empresa</div>
                        <p className="orgproc-card-desc">
                          Define qué logo llevará el encabezado de la
                          documentación generada para este proyecto.
                        </p>
                        <div className="docgen-empresa-selector" role="radiogroup" aria-label="Empresa">
                          {EMPRESAS.map((empresa) => (
                            <button
                              key={empresa.id}
                              type="button"
                              role="radio"
                              aria-checked={empresaNuevoProyecto === empresa.id}
                              className={
                                "docgen-empresa-option" +
                                (empresaNuevoProyecto === empresa.id
                                  ? " docgen-empresa-option--activa"
                                  : "")
                              }
                              onClick={() => setEmpresaNuevoProyecto(empresa.id)}
                            >
                              <img
                                src={empresa.logo}
                                alt={`Logo ${empresa.nombre}`}
                                className="docgen-empresa-logo"
                              />
                              <span className="docgen-empresa-nombre">{empresa.nombre}</span>
                            </button>
                          ))}
                        </div>

                        <div className="docgen-empresa-label">Tiempo límite</div>
                        <p className="orgproc-card-desc">
                          Días disponibles para completar todo el proyecto
                          (los 6 pasos). Se reparte en partes iguales entre
                          cada paso para calcular sus fechas límite.
                        </p>
                        <input
                          type="number"
                          min={1}
                          className="docgen-name-input"
                          value={diasLimiteNuevoProyecto}
                          onChange={(event) =>
                            setDiasLimiteNuevoProyecto(event.target.value)
                          }
                        />

                        {errorProyectos && (
                          <p className="docgen-output-hint docgen-output-hint--error">
                            {errorProyectos}
                          </p>
                        )}

                        <div className="docgen-card-actions">
                          <button
                            type="submit"
                            className="orgproc-card-btn"
                            disabled={!nombreNuevoProyecto.trim() || creandoProyecto}
                          >
                            {creandoProyecto ? "Guardando..." : "Crear proyecto →"}
                          </button>
                          {proyectos.length > 0 && (
                            <button
                              type="button"
                              className="docgen-cancel-btn"
                              onClick={cancelarCreacionProyecto}
                              disabled={creandoProyecto}
                            >
                              Cancelar
                            </button>
                          )}
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {vista === "proyecto" && (
            <div className="docgen-main">
              {proyectoActivo && (
                <div className="orgproc-header">
                  <h1 className="orgproc-heading">{proyectoActivo.nombre}</h1>
                </div>
              )}

              {proyectoCompletado && (
                <div className="docgen-completado">
                  <div className="docgen-completado-banner">🎉 Proyecto completado</div>
                  <p className="orgproc-card-desc">
                    Descarga aquí cada uno de los documentos finales del proyecto.
                  </p>

                  {cargandoProyectoCompletado && (
                    <p className="docgen-output-hint">Cargando documentos finales...</p>
                  )}
                  {!cargandoProyectoCompletado && errorProyectoCompletado && (
                    <p className="docgen-output-hint docgen-output-hint--error">
                      {errorProyectoCompletado}
                    </p>
                  )}

                  {!cargandoProyectoCompletado && (
                    <div className="docgen-completado-lista">
                      {pasos.map((paso) => {
                        const info = archivosProyectoCompletado[paso.numero];
                        const archivosPaso = (info && info.archivos) || [];
                        return (
                          <div key={paso.numero} className="docgen-completado-item">
                            <div className="docgen-completado-item-info">
                              <span className="docgen-completado-item-nombre">
                                {paso.numero}. {paso.salida}
                              </span>
                              {info && (
                                <span className="docgen-completado-item-version">
                                  v{info.version}
                                  {info.esFinal ? " (final)" : ""}
                                </span>
                              )}
                            </div>
                            {archivosPaso.length > 0 ? (
                              <div className="docgen-completado-item-descargas">
                                {archivosPaso.map((archivo) => (
                                  <button
                                    key={archivo.key}
                                    type="button"
                                    className="docgen-cancel-btn"
                                    onClick={() => descargarArchivoFinal(archivo)}
                                  >
                                    Descargar {archivo.nombreArchivo}
                                  </button>
                                ))}
                              </div>
                            ) : (
                              <span className="docgen-output-hint">Sin documento guardado</span>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              )}

              {!proyectoCompletado && (
              <>
              <div className="docgen-steps">
                {pasos.map((paso, index) => {
                  const esCompletado = paso.numero < pasoActivo;
                  const esActivo = paso.numero === pasoActivo;
                  const bloqueado =
                    pasoActivo > PASO_SIN_RETROCESO && paso.numero < pasoActivo;
                  return (
                  <React.Fragment key={paso.numero}>
                    <button
                      type="button"
                      className={
                        "docgen-step" +
                        (esActivo ? " docgen-step--activo" : "") +
                        (bloqueado ? " docgen-step--bloqueado" : "")
                      }
                      onClick={() => irAPaso(paso.numero)}
                      disabled={bloqueado}
                      title={
                        bloqueado
                          ? "Ya no se puede regresar a este paso una vez que se avanza a Agreement."
                          : undefined
                      }
                    >
                      <div
                        className={
                          "docgen-step-circle" +
                          (esCompletado
                            ? " docgen-step-circle--completado"
                            : esActivo
                            ? " docgen-step-circle--activo"
                            : "")
                        }
                      >
                        {paso.numero}
                      </div>
                      <div className="docgen-step-label">{paso.titulo}</div>
                    </button>
                    {index < pasos.length - 1 && (
                      <div className="docgen-connector" aria-hidden="true">
                        →
                      </div>
                    )}
                  </React.Fragment>
                  );
                })}
              </div>

              <div className="docgen-grid">
                <div className="orgproc-card docgen-paso-card">
                  <div className="orgproc-card-accent"></div>
                  <div className="orgproc-card-body">
                    <div className="orgproc-eyebrow">
                      Paso {pasoActual.numero} de {pasos.length}
                      {versionActualPasoActivo > 1 ? (
                        <select
                          className="docgen-version-select"
                          value={versionSeleccionada}
                          onChange={(event) => setVersionSeleccionada(Number(event.target.value))}
                          title="Elegir la versión del documento a visualizar"
                        >
                          {Array.from({ length: versionActualPasoActivo }, (_, i) => i + 1).map((v) => (
                            <option key={v} value={v}>
                              v{v}
                              {v === versionActualPasoActivo ? " (actual)" : ""}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <span className="docgen-version-badge">v{versionActualPasoActivo}</span>
                      )}
                      {versionActivaFinalizada && (
                        <span className="docgen-version-badge docgen-version-badge--final">
                          ✓ Final
                        </span>
                      )}
                    </div>
                    <div className="orgproc-card-title">{pasoActual.titulo}</div>

                    {pasoActivo === PASO_SIN_RETROCESO && (
                      <div className="docgen-alerta docgen-alerta--proximo">
                        ⚠️ Si avanzas al siguiente paso (Agreement), el proceso se
                        vuelve definitivo: ya no podrás regresar a pasos
                        anteriores.
                      </div>
                    )}

                    {pasoActivo > PASO_SIN_RETROCESO && (
                      <div></div>
                    )}

                    {!estaViendoVersionActual && (
                      <div className="docgen-alerta docgen-historial-alerta">
                        <span>
                          👁 Viendo la versión {versionSeleccionada} de este
                          paso (solo lectura).
                        </span>
                        <button
                          type="button"
                          className="docgen-cancel-btn"
                          onClick={() => setVersionSeleccionada(versionActualPasoActivo)}
                        >
                          Volver a la versión actual (v{versionActualPasoActivo})
                        </button>
                      </div>
                    )}

                    {estaViendoVersionActual && (
                      <>
                        {!versionActivaFinalizada && mostrarZonaCarga && (
                          <>
                            <p className="orgproc-card-desc">
                              {PASOS_GENERADOS_DESDE_MACHOTE.includes(pasoActual.numero) ? (
                                <>
                                  Genera el documento con el machote y descárgalo para
                                  afinarlo en Word (montos, textos, tablas). Cuando tengas
                                  la versión final, súbela aquí: sustituirá al machote
                                  generado como el documento vigente de este paso.
                                </>
                              ) : (
                                <>
                                  Ingresa el siguiente documento: {pasoActual.entrada} A
                                  partir de este documento se generará la documentación de
                                  este paso usando el machote correspondiente.
                                </>
                              )}
                            </p>
                            <label
                              className="docgen-upload-dropzone"
                              htmlFor={`paso-${pasoActual.numero}-input`}
                            >
                              <input
                                key={pasoActual.numero}
                                id={`paso-${pasoActual.numero}-input`}
                                type="file"
                                className="docgen-upload-input"
                                accept={pasoActual.entradaAccept}
                                multiple={esPasoMultiple(pasoActual.numero)}
                                onChange={handleArchivoChange}
                              />
                              <span className="docgen-upload-icon">⬆</span>
                              <span className="docgen-upload-text">
                                {archivos.length === 0 &&
                                  `Selecciona o arrastra el documento de ${pasoActual.titulo}`}
                                {archivos.length === 1 && archivos[0].name}
                                {archivos.length > 1 && `${archivos.length} archivos seleccionados`}
                              </span>
                            </label>
                          </>
                        )}

                        {cargandoArchivosPaso && (
                          <p className="docgen-output-hint">Recuperando archivos guardados de este paso...</p>
                        )}
                        {subiendoArchivo && (
                          <p className="docgen-output-hint">Guardando en el histórico de S3...</p>
                        )}
                        {!subiendoArchivo && errorSubida && (
                          <p className="docgen-output-hint docgen-output-hint--error">
                            {errorSubida}
                          </p>
                        )}

                        {archivos.length > 0 && (
                          <div className="docgen-archivos-lista">
                            {archivos.map((file, indice) => (
                              <div key={`${file.name}-${indice}`} className="docgen-archivo-chip">
                                <span className="docgen-archivo-chip-icon">📄</span>
                                <div className="docgen-archivo-chip-info">
                                  <span className="docgen-archivo-chip-name">{file.name}</span>
                                  <span className="docgen-archivo-chip-size">
                                    {formatearTamanio(file.size)}
                                  </span>
                                </div>
                                <a
                                  href={previewUrls[indice]}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="docgen-archivo-chip-abrir"
                                  title="Abrir archivo"
                                >
                                  Abrir
                                </a>
                                <button
                                  type="button"
                                  className="docgen-preview-quitar"
                                  onClick={() => quitarArchivo(indice)}
                                  aria-label={`Quitar ${file.name}`}
                                  title="Quitar archivo"
                                >
                                  ✕
                                </button>
                              </div>
                            ))}
                          </div>
                        )}

                        {(mostrarBotonVersion || mostrarBotonFinal) && (
                          <div className="docgen-version-acciones">
                            {mostrarBotonVersion && (
                              <button
                                type="button"
                                className="docgen-cancel-btn docgen-version-btn"
                                onClick={realizarCambioVersion}
                                disabled={cambiandoVersion || subiendoArchivo}
                                title="Sube o genera un nuevo documento para este paso, conservando la versión anterior en el histórico de S3."
                              >
                                {cambiandoVersion
                                  ? "Preparando nueva versión..."
                                  : `↻ Realizar un cambio (crear versión ${versionActualPasoActivo + 1})`}
                              </button>
                            )}
                            {mostrarBotonFinal && (
                              <button
                                type="button"
                                className="docgen-cancel-btn docgen-version-final-btn"
                                onClick={marcarVersionComoFinal}
                                title="Marca esta versión como definitiva: ya no se podrán crear nuevas versiones de este paso."
                              >
                                🏁 Marcar como versión final
                              </button>
                            )}
                          </div>
                        )}

                        {versionActivaFinalizada && (
                          <p className="docgen-output-hint">
                            Esta es la versión final de este paso: ya no se pueden crear nuevas versiones.
                          </p>
                        )}

                        {pasoActual.numero === PASO_KICKOFF && (
                          <div className="docgen-firmante">
                            <div className="docgen-empresa-label">Presentación de Kick-off</div>
                            <p className="orgproc-card-desc">
                              Se genera con el nombre del proyecto, el logo del
                              cliente y de la empresa, y los Objetivos del
                              Estudio, el BOM y el Cronograma heredados del
                              BOM del paso 2.
                            </p>
                          </div>
                        )}

                        {pasoActual.numero === PASO_BOM && (
                          <div className="docgen-origen-selector">
                            <span>Basado en la versión del Assessment:</span>
                            <select
                              value={versionOrigenBOM}
                              onChange={(event) =>
                                setOrigenSeleccionado((prev) => ({
                                  ...prev,
                                  [PASO_BOM]: Number(event.target.value),
                                }))
                              }
                            >
                              {Array.from({ length: versionAssessmentActual }, (_, i) => i + 1).map((v) => (
                                <option key={v} value={v}>
                                  v{v}
                                  {estaVersionFinalizada(PASO_ASSESSMENT) && v === versionAssessmentActual
                                    ? " (final)"
                                    : ""}
                                </option>
                              ))}
                            </select>
                          </div>
                        )}

                        {pasoActual.numero === PASO_PROPUESTA_TECNICO_FUNCIONAL && (
                          <div className="docgen-origen-selector">
                            <span>Basado en la versión del BOM:</span>
                            <select
                              value={versionOrigenEconomica}
                              onChange={(event) =>
                                setOrigenSeleccionado((prev) => ({
                                  ...prev,
                                  [PASO_PROPUESTA_TECNICO_FUNCIONAL]: Number(event.target.value),
                                }))
                              }
                            >
                              {Array.from({ length: versionBOMActual }, (_, i) => i + 1).map((v) => (
                                <option key={v} value={v}>
                                  v{v}
                                  {estaVersionFinalizada(PASO_BOM) && v === versionBOMActual ? " (final)" : ""}
                                </option>
                              ))}
                            </select>
                          </div>
                        )}

                        {pasoActual.numero === PASO_PROPUESTA_COMERCIAL && (
                          <div className="docgen-origen-selector">
                            <span>Basado en la versión del BOM:</span>
                            <select
                              value={versionOrigenPropuesta}
                              onChange={(event) =>
                                setOrigenSeleccionado((prev) => ({
                                  ...prev,
                                  [PASO_PROPUESTA_COMERCIAL]: Number(event.target.value),
                                }))
                              }
                            >
                              {Array.from({ length: versionBOMActual }, (_, i) => i + 1).map((v) => (
                                <option key={v} value={v}>
                                  v{v}
                                  {estaVersionFinalizada(PASO_BOM) && v === versionBOMActual ? " (final)" : ""}
                                </option>
                              ))}
                            </select>
                          </div>
                        )}

                        {pasoActual.numero === PASO_KICKOFF && (
                          <div className="docgen-origen-selector">
                            <span>Basado en la versión del BOM:</span>
                            <select
                              value={versionOrigenKickoff}
                              onChange={(event) =>
                                setOrigenSeleccionado((prev) => ({
                                  ...prev,
                                  [PASO_KICKOFF]: Number(event.target.value),
                                }))
                              }
                            >
                              {Array.from({ length: versionBOMActual }, (_, i) => i + 1).map((v) => (
                                <option key={v} value={v}>
                                  v{v}
                                  {estaVersionFinalizada(PASO_BOM) && v === versionBOMActual ? " (final)" : ""}
                                </option>
                              ))}
                            </select>
                          </div>
                        )}

                        {pasoActual.numero !== PASO_ASSESSMENT && (
                          <div className="docgen-output">
                            <div className="docgen-output-header">Documento generado</div>
                            <div className="docgen-output-body">
                              <span className="docgen-output-icon">📄</span>
                              <div className="docgen-output-text">
                                <div className="docgen-output-name">{pasoActual.salida}</div>
                                <div className="docgen-output-format">
                                  Formato:{" "}
                                  {pasoActual.numero === PASO_BOM ||
                                  pasoActual.numero === PASO_PROPUESTA_TECNICO_FUNCIONAL ||
                                  pasoActual.numero === PASO_PROPUESTA_COMERCIAL
                                    ? "Word"
                                    : pasoActual.formatoSalida}
                                </div>
                              </div>
                              <div className="docgen-output-actions">
                                {pasoActual.numero === PASO_BOM && (
                                  <button
                                    type="button"
                                    className={
                                      "orgproc-card-btn" + (!generandoBOM ? "" : " orgproc-card-btn--disabled")
                                    }
                                    disabled={generandoBOM}
                                    onClick={() => generarBOMDesdeVersionAssessment(versionOrigenBOM)}
                                  >
                                    {generandoBOM ? "Generando..." : bomBlob ? "Regenerar BOM" : "Generar BOM"}
                                  </button>
                                )}
                                {pasoActual.numero === PASO_PROPUESTA_TECNICO_FUNCIONAL && (
                                  <button
                                    type="button"
                                    className="orgproc-card-btn"
                                    disabled={generandoEconomica}
                                    onClick={() => setEconomicaModalAbierta(true)}
                                  >
                                    {economicaBlob ? "Regenerar propuesta" : "Generar propuesta"}
                                  </button>
                                )}
                                {pasoActual.numero === PASO_PROPUESTA_COMERCIAL && (
                                  <button
                                    type="button"
                                    className="orgproc-card-btn"
                                    disabled={generandoPropuesta}
                                    onClick={() => setPropuestaModalAbierta(true)}
                                  >
                                    {propuestaBlob ? "Regenerar propuesta" : "Generar propuesta"}
                                  </button>
                                )}
                                {pasoActual.numero === PASO_KICKOFF && (
                                  <button
                                    type="button"
                                    className={
                                      "orgproc-card-btn" + (!generandoKickoff ? "" : " orgproc-card-btn--disabled")
                                    }
                                    disabled={generandoKickoff}
                                    onClick={generarKickoff}
                                  >
                                    {generandoKickoff
                                      ? "Generando..."
                                      : kickoffBlob
                                      ? "Regenerar Kick-off"
                                      : "Generar Kick-off"}
                                  </button>
                                )}
                                <button
                                  type="button"
                                  className={
                                    "orgproc-card-btn" +
                                    ((pasoActual.numero === PASO_BOM && bomBlob) ||
                                    (pasoActual.numero === PASO_PROPUESTA_TECNICO_FUNCIONAL && economicaBlob) ||
                                    (pasoActual.numero === PASO_PROPUESTA_COMERCIAL && propuestaBlob) ||
                                    (pasoActual.numero === PASO_KICKOFF && kickoffBlob)
                                      ? ""
                                      : " orgproc-card-btn--disabled")
                                  }
                                  disabled={
                                    !(
                                      (pasoActual.numero === PASO_BOM && bomBlob) ||
                                      (pasoActual.numero === PASO_PROPUESTA_TECNICO_FUNCIONAL && economicaBlob) ||
                                      (pasoActual.numero === PASO_PROPUESTA_COMERCIAL && propuestaBlob) ||
                                      (pasoActual.numero === PASO_KICKOFF && kickoffBlob)
                                    )
                                  }
                                  onClick={
                                    pasoActual.numero === PASO_PROPUESTA_TECNICO_FUNCIONAL
                                      ? descargarEconomica
                                      : pasoActual.numero === PASO_PROPUESTA_COMERCIAL
                                      ? descargarPropuesta
                                      : pasoActual.numero === PASO_KICKOFF
                                      ? descargarKickoff
                                      : descargarBOM
                                  }
                                >
                                  Descargar →
                                </button>
                              </div>
                            </div>
                            {pasoActual.numero === PASO_BOM && (
                              <p className="docgen-output-hint">
                                {errorBOM
                                  ? errorBOM
                                  : bomBlob
                                  ? "BOM generado heredando logos y secciones de la versión de Assessment elegida."
                                  : "Sube un Assessment en .docx en el paso 1 y presiona \"Siguiente paso\", o usa \"Generar BOM\" eligiendo la versión de origen."}
                              </p>
                            )}
                            {pasoActual.numero === PASO_PROPUESTA_TECNICO_FUNCIONAL && (
                              <p className="docgen-output-hint">
                                {errorEconomica
                                  ? errorEconomica
                                  : economicaBlob
                                  ? "Propuesta técnico-económica generada heredando referencia de cliente, cronograma y equipo participante de la versión de BOM elegida."
                                  : "Presiona \"Generar propuesta\" para ingresar el firmante, la moneda y si lleva IVA, y crear el documento."}
                              </p>
                            )}
                            {pasoActual.numero === PASO_PROPUESTA_COMERCIAL && (
                              <p className="docgen-output-hint">
                                {errorPropuesta
                                  ? errorPropuesta
                                  : propuestaBlob
                                  ? "Propuesta comercial generada con los datos del proyecto, cliente y firmante."
                                  : "Presiona \"Generar propuesta\" para ingresar los datos del firmante y crear el documento."}
                              </p>
                            )}
                            {pasoActual.numero === PASO_KICKOFF && (
                              <p className="docgen-output-hint">
                                {errorKickoff
                                  ? errorKickoff
                                  : kickoffBlob
                                  ? "Kick-off generado heredando logos, objetivos, BOM y cronograma de la versión de BOM elegida."
                                  : "Presiona \"Generar Kick-off\" para crear la presentación."}
                              </p>
                            )}
                            {pasoActual.numero === PASO_KICKOFF && kickoffBlob && !proyectoActivo?.completado && (
                              <button
                                type="button"
                                className="orgproc-card-btn docgen-finalizar-btn"
                                onClick={finalizarProyecto}
                              >
                                🏁 Confirmar proyecto
                              </button>
                            )}
                            {pasoActual.numero !== PASO_BOM &&
                              pasoActual.numero !== PASO_PROPUESTA_TECNICO_FUNCIONAL &&
                              pasoActual.numero !== PASO_PROPUESTA_COMERCIAL &&
                              pasoActual.numero !== PASO_KICKOFF && (
                                <p className="docgen-output-hint">
                                  La generación automática de este documento estará
                                  disponible próximamente.
                                </p>
                              )}
                          </div>
                        )}
                      </>
                    )}

                    {!estaViendoVersionActual && (
                      <div className="docgen-historial-panel">
                        {cargandoHistorico && (
                          <p className="docgen-output-hint">Cargando archivos de esta versión...</p>
                        )}
                        {!cargandoHistorico && errorHistorico && (
                          <p className="docgen-output-hint docgen-output-hint--error">{errorHistorico}</p>
                        )}
                        {!cargandoHistorico && !errorHistorico && archivosHistoricos.length === 0 && (
                          <p className="docgen-output-hint">Esta versión no tiene archivos guardados.</p>
                        )}
                        {archivosHistoricos.length > 0 && (
                          <div className="docgen-archivos-lista">
                            {archivosHistoricos.map((archivo) => (
                              <div key={archivo.key} className="docgen-archivo-chip">
                                <span className="docgen-archivo-chip-icon">
                                  {archivo.tipo === "generado" ? "📄" : "📎"}
                                </span>
                                <div className="docgen-archivo-chip-info">
                                  <span className="docgen-archivo-chip-name">{archivo.nombreArchivo}</span>
                                  <span className="docgen-archivo-chip-size">
                                    {archivo.tipo === "generado" ? "Generado" : "Cargado"} ·{" "}
                                    {formatearTamanio(archivo.tamanio)}
                                  </span>
                                </div>
                                <button
                                  type="button"
                                  className="docgen-archivo-chip-abrir"
                                  onClick={() => abrirArchivoHistorico(archivo)}
                                >
                                  Descargar
                                </button>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    )}

                    <div className="docgen-step-nav">
                      <button
                        type="button"
                        className="docgen-cancel-btn"
                        onClick={irAPasoAnterior}
                        disabled={pasoActivo === 1 || pasoActivo > PASO_SIN_RETROCESO}
                        title={
                          pasoActivo > PASO_SIN_RETROCESO
                            ? "Ya no se puede regresar después de Agreement."
                            : undefined
                        }
                      >
                        ← Paso anterior
                      </button>
                      <button
                        type="button"
                        className="orgproc-card-btn"
                        onClick={avanzarPaso}
                        disabled={pasoActivo === pasos.length || generandoBOM || !estaViendoVersionActual}
                        title={
                          !estaViendoVersionActual
                            ? "Vuelve a la versión actual para continuar."
                            : undefined
                        }
                      >
                        {generandoBOM ? "Procesando..." : "Siguiente paso →"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              </>
              )}
            </div>
            )}

            {vista === "proyecto" && proyectoActivo && (
              <CalendarioProyecto
                proyecto={proyectoActivo}
                pasoActivo={pasoActivo}
                titulosPasos={pasos.map((paso) => paso.titulo)}
                onExtenderPlazo={extenderPlazoProyecto}
              />
            )}
          </div>
        )}
      </Container>

      <RevisionOrtografica
        abierto={revisionAbierta}
        datos={datosAssessment}
        onConfirmar={confirmarRevisionOrtografica}
        onCancelar={cancelarRevisionOrtografica}
      />

      {economicaModalAbierta && (
        <EconomicaModal
          firmante={firmante}
          setFirmante={setFirmante}
          moneda={moneda}
          setMoneda={setMoneda}
          tieneIVA={tieneIVA}
          setTieneIVA={setTieneIVA}
          errorEconomica={errorEconomica}
          generandoEconomica={generandoEconomica}
          economicaBlob={economicaBlob}
          firmanteCompleto={firmanteCompleto}
          onCancelar={() => setEconomicaModalAbierta(false)}
          onConfirmar={confirmarGenerarEconomicaDesdeModal}
        />
      )}

      {propuestaModalAbierta && (
        <PropuestaComercialModal
          firmante={firmante}
          setFirmante={setFirmante}
          moneda={moneda}
          setMoneda={setMoneda}
          errorPropuesta={errorPropuesta}
          generandoPropuesta={generandoPropuesta}
          propuestaBlob={propuestaBlob}
          firmanteCompleto={firmanteCompleto}
          onCancelar={() => setPropuestaModalAbierta(false)}
          onConfirmar={confirmarGenerarPropuestaDesdeModal}
        />
      )}
    </>
  );
};

export default CreacionDocumentacion;